import React from 'react'
import BxlEditor, { Toolbar, ToolbarGroup, Image } from 'bxl-editor'
import { uploadProductImage } from '@services/productService'

// 商品富文本编辑器，目前支持图文详情
function ProductRichTextEditor (props: any) {
  const { value, onChange, readOnly = false } = props

  const onSimpleRequest = (options, onProgress): Promise<any> => {
    const { file, name, extension, width, height } = options
    const form = new FormData()
    form.append('thumbnail', file, name + '.' + extension)
    form.append('thumbdim', `${width}x${height}`)
    form.append('full', file, name + '.' + extension)
    form.append('fulldim', `${width}x${height}`)
    form.append('format', extension)
    form.append('topic', 'IMAGE_TEXT')
    return uploadProductImage(form, onProgress)
  }

  const parseImageResponse = (res: any) => {
    const image = res.full || res.thumbnail
    const content = document.body.querySelector('.ce-editor-content') as HTMLElement
    const scale = content?.offsetWidth ? (1.0 * image?.width / content?.offsetWidth) : 1
    return {
      url: image?.url || '',
      format: image?.format || 'jpg',
      width: image?.width ? image?.width / scale : 0,
      height: image?.height ? image?.height / scale : 0,
    }
  }

  return (
    <div>
      <BxlEditor
        value={value}
        readOnly={readOnly}
        onChange={onChange}
        options={{
          uploadImage: onSimpleRequest,
          parseImageResponse: parseImageResponse,
        }}
        plugins={
          <Toolbar>
            <ToolbarGroup>
              <Image simpleRequest={onSimpleRequest} transformResponse={parseImageResponse} />
            </ToolbarGroup>
          </Toolbar>
        }
      />
    </div>
  )
}

export default ProductRichTextEditor
